import { render, staticRenderFns } from "./add-prescription.vue?vue&type=template&id=3e89a21b"
import script from "./add-prescription.vue?vue&type=script&lang=js"
export * from "./add-prescription.vue?vue&type=script&lang=js"
import style0 from "./add-prescription.vue?vue&type=style&index=0&id=3e89a21b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports